import Papa from "papaparse";
import { downloadFile } from "src/utils/files";
import { getTrainingRevisionNumber } from "./revision-label";
import {
  formatTrainingMatrixDateTime,
  formatTrainingUserName,
  type TaskProgramUserMatrixRow,
} from "./training-user-matrix";

export const buildTrainingMatrixCsv = (
  rows: TaskProgramUserMatrixRow[]
): string =>
  Papa.unparse(
    rows.flatMap((row) =>
      row.assignments.map((assignment) => ({
        "User name": formatTrainingUserName(row.trainee),
        "Functional group": assignment.functionalGroups
          .map((group) => `${group.name} (${group.acronym})`)
          .join("; "),
        "Document name": assignment.documentTitle,
        "Document number": assignment.documentId,
        "Document revision":
          assignment.status === "NOT_ISSUED"
            ? "Not yet issued"
            : assignment.revision != null
              ? `R${getTrainingRevisionNumber(assignment.revision)}`
              : "",
        "Date training assigned": formatTrainingMatrixDateTime(
          assignment.assignedAt
        ),
        "Date training due": formatTrainingMatrixDateTime(assignment.dueDate),
        "Date training completed": formatTrainingMatrixDateTime(
          assignment.completedAt
        ),
        "Method of completion":
          assignment.status === "NOT_ISSUED"
            ? ""
            : assignment.completionMethod === "QUIZ"
              ? "Quiz and signature"
              : "Reading comprehension",
      }))
    ),
    { escapeFormulae: true }
  );

export const downloadTrainingMatrixCsv = async (
  rows: TaskProgramUserMatrixRow[],
  exportedAt = new Date()
) => {
  await downloadFile(
    new Blob(["\uFEFF", buildTrainingMatrixCsv(rows)], {
      type: "text/csv;charset=utf-8",
    }),
    `training-matrix-${exportedAt.toISOString().slice(0, 10)}.csv`
  );
};
